import React, { useState } from "react";
import { object, array, number, string } from "prop-types";

import StoryElements, { Card } from "../story-elements";
import StoryHeader from "../header-block";
import StorySideBar from "../story-sidebar-elements";

import { getTitleAndCards } from "../../utils/utils";

import "./explainer-story.m.css";

const StoryContent = ({ story, firstCard, cards }) => {
  if (!cards.length) return null;

  const [isOpen, setIsopen] = useState({});

  const showCardDetails = (id) => () =>
    setIsopen({
      ...isOpen,
      [id]: !isOpen[id],
    });

  const newCards = getTitleAndCards(cards);

  return (
    <div>
      <Card key={firstCard.id} card={firstCard} story={story} />
      <div styleName="explainer-card">
        <h2 styleName="explainer-head">{story.headline}</h2>
        <ol styleName="items">
          {newCards.length &&
            newCards.map(({ title, card }, index) => (
              <li styleName="item" key={index} id={card.id}>
                <h2 styleName="title" onClick={showCardDetails(card.id)}>
                  {`${index + 1}. ${title.text}`}
                </h2>
                <div styleName={`body ${isOpen[card.id] ? "active" : ""}`}>
                  <Card key={card.id} card={card} story={story} />
                </div>
                <div styleName="show-more" onClick={showCardDetails(card.id)}>
                  {isOpen[card.id] ? "Collapse" : "Expand"}
                  <span styleName={`${isOpen[card.id] ? "up" : "down"}-arrow`} />
                </div>
              </li>
            ))}
        </ol>
      </div>
    </div>
  );
};

StoryContent.propTypes = {
  story: object,
  firstCard: object,
  cards: array,
};

const ExplainerStory = ({ story, index, publisherName }) => {
  const [firstCard, ...cards] = story.cards;

  return (
    <div styleName="story-wrapper">
      <div>
        <StoryHeader story={story} />
        <StoryContent publisherName={publisherName} story={story} firstCard={firstCard} cards={cards} />
        <StoryElements story={story} cards={cards} displayMoreNews={false} index={index} />
      </div>
      <div>
        <StorySideBar index={index} story={story} />
      </div>
    </div>
  );
};

ExplainerStory.propTypes = {
  story: object,
  index: number,
  publisherName: string,
};

export default ExplainerStory;
